<template>
	<div 
		:class="['tffi-card', 'tffi-card-summary-card', { 'cursor-pointer': clickable }]"
		@click="handleClick"
	>
		<!-- Loan Program -->
		<template v-if="!program.leaseTermMonths">
			<div class="tffi-card-summary-card__top-area theming primary-color">
				<div class="tffi-card-summary-card__top-area__overlay-image"></div>
				<div class="tffi-card-summary-card__top-area__title-area">
					<h2>{{ displayTitle }}</h2>
				</div>
				<div class="tffi-card-summary-card__top-area__financed-amount">
					<p v-if="program.invoicedAmount">Invoiced Amount: <span
							class="tffi-card-summary-card__top-area__financed-amount__price">${{
							program.invoicedAmount |
							formatMoney }}</span></p>
				</div>
				<div class="tffi-card-summary-card__top-area__financed-amount">
					<p>Search & Registration Fee: <span
							class="tffi-card-summary-card__top-area__financed-amount__price">${{ program.fee |
							formatMoney }}</span></p>
				</div>
				<div class="tffi-card-summary-card__top-area__financed-amount">
					<p v-if="program.isStepLoan && program.amount">Financed Amount: <span
							class="tffi-card-summary-card__top-area__financed-amount__price">${{ program.amount |
							formatMoney }}</span></p>
				</div>

				<div class="tffi-card-summary-card__top-area__financed-amount">
					<p v-if="!program.isStepLoan && program.financedAmount">Financed Amount: <span
							class="tffi-card-summary-card__top-area__financed-amount__price">{{
							program.financedAmount |
							formatMoney }}</span></p>

					<p
						v-if="!program.isStepLoan && program.leaseTermMonths && program.totalPayments">
						Financed Amount: <span class="tffi-card-summary-card__top-area__financed-amount__price">${{
							program.totalPayments |
							formatMoney }}</span></p>
				</div>
			</div>
			<div class="tffi-card-summary-card__bottom-area">

				<div v-if="program.programType" class="tffi-card-summary-card__bottom-area__label">
					<p class="mb-1">Program Type:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class=" capitalize">{{ (program.programType) }}</p>
				</div>
				<div v-if="!program.leaseTermMonths" class="tffi-card-summary-card__bottom-area__label">
					<p class="mb-1">Deferral Length:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class=" capitalize">{{ (program.deferralPeriod ? program.deferralPeriod + ' Months'
						: 'NA') }}</p>
				</div>
				<div v-if="program.frequency" class="tffi-card-summary-card__bottom-area__label mb-0">
					<p class="">Payment Frequency:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.frequencyName }}</p>
				</div>


				<div v-if="program.phaseOneTerm && program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p :class="program.isStepLoan ? 'mb-1' : ''">Promotion Duration:</p><span
						class=" flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.phaseOneTerm }} Months</p>
				</div>
				<div v-if="program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p :class="program.isStepLoan ? 'mb-1' : ''">Promotional Rate:</p><span
						class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ ((program.annualRateOne || 0) * 100).toFixed(2) }}%</p>
				</div>
				<div v-if="program.periodPaymentPhaseOne && program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p class="theming primary-color fw-bold">Promotional Payment:</p><span class=" flex-grow-1 d-none
						d-lg-flex"></span>
					<p class="theming primary-color fw-bold">${{ program.periodPaymentPhaseOne | formatMoney }}
					</p>
				</div>

				<div v-if="program.monthly" class="tffi-card-summary-card__bottom-area__label">
					<p class="theming primary-color fw-bold">Base Monthly Payment:</p>
					<span class="flex-grow-1"></span>
					<p class="theming primary-color fw-bold">${{ program.monthly | formatMoney }}</p>
				</div>

				<div v-if=" program.phaseTwoTerm && program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p :class="program.isStepLoan ? 'mb-1' : ''">Remaining Duration:</p><span
						class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.phaseTwoTerm }} Months</p>
				</div>
				<div v-if="program.rate != null && !program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p class="mb-1">Rate: </p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.rate }}%</p>
				</div>
				<div v-if="program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p class="mb-1">Rate:</p><span class="flex-grow-1 d-none d-lg-flex"></span>
					<p> {{ ((program.annualRateTwo || 0) * 100).toFixed(2) }}%</p>
				</div>
				<div v-if="program.periodPaymentPhaseTwo && program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p class="theming primary-color fw-bold">Payment:</p><span class=" flex-grow-1 d-none d-lg-flex">
					</span>
					<p class="theming primary-color fw-bold">${{ program.periodPaymentPhaseTwo | formatMoney }}
					</p>
				</div>


				<div v-if=" program.amortTerm" class="tffi-card-summary-card__bottom-area__label">
					<p :class="!program.isStepLoan ?? 'mb-1'">Amortization Term:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.amortizationTerm }} Months</p>
				</div>


				<div v-if="program.aprGuess && program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p>Effective APR:</p><span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ (program.apr * 100).toFixed(2) }}%</p>
				</div>


				<div v-if="program.leasingPeriod" class="tffi-card-summary-card__bottom-area__label">
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ $t('financingProgram.leasingPeriod') }}: {{ program.leasingPeriod || 'N/A' }} </p>
				</div>

				<div v-if="program.term && !program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p>Finance Term:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ program.actualTerm }} Months</p>
				</div>

				<div v-if="program.periodPayment && !program.isStepLoan"
					class="tffi-card-summary-card__bottom-area__label">
					<p class="theming primary-color fw-bold mb-0">Payment: </p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class="theming primary-color fw-bold mb-0">${{ program.periodPayment | formatMoney }}</p>
				</div>
			</div>
		</template>

		<!-- Lease Program -->
		<template v-else>
			<div class="tffi-card-summary-card__top-area theming primary-color">
				<div class="tffi-card-summary-card__top-area__overlay-image"></div>
				<div class="tffi-card-summary-card__top-area__title-area">
					<h2>Lease Program</h2>
				</div>
			</div>
			<div class="tffi-card-summary-card__bottom-area">
				<div class="tffi-card-summary-card__bottom-area__label lease-preview-highlight">
					<p class="theming primary-color fw-bold">Monthly Payment (before tax):</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class="theming primary-color fw-bold">${{ (program.payment ?? program.initialPayment) | formatMoney }}</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Sales Tax Rate:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>{{ (Number(program.taxRate || 0) * 100).toFixed(2) }}%</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Monthly Payment (tax included):</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>${{ (program.paymentWithTax ?? program.initialPaymentWithTax) | formatMoney }}</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Amortization Term:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class="theming">{{ program.leaseTermMonths }} month</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label lease-preview-highlight">
					<p class="theming primary-color fw-bold">Equipment Value:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p class="theming primary-color fw-bold">${{ (program.equipmentValue ?? program.equipmentPrice) | formatMoney }}</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Total Payments (tax included):</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>${{ program.totalPaymentsWithTax | formatMoney }}</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Total Lease Cost:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>${{ program.totalLeaseCost | formatMoney }}</p>
				</div>
				<div class="tffi-card-summary-card__bottom-area__label">
					<p>Implicit Finance Charge:</p>
					<span class="flex-grow-1 d-none d-lg-flex"></span>
					<p>${{ program.implicitFinanceCharge | formatMoney }}</p>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'ProgramSummaryCard',
	props: {
		program: {
			type: Object,
			required: true,
			default: () => ({})
		},
		programType: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: null
		},
		clickable: {
			type: Boolean,
			default: false
		},
		clickHandler: {
			type: Function,
			default: null
		}
	},
	computed: {
		displayTitle() {
			return this.title || this.programType || 'Program';
		}
	},
	filters: {
		formatMoney(value) {
			if (value == null || value === undefined) return '0.00';
			return new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(value);
		},
	},
	methods: {
		handleClick() {
			if (this.clickable && this.clickHandler) {
				this.clickHandler();
			}
		}
	}
};
</script>

<style scoped>
.lease-preview-highlight {
	border-left: 3px solid var(--primary-color);
	/* padding-left: 0.5rem; */
}
</style>
